export const LimitIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
		<rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#F0F0F0" />
		<path
			d="M10 22V13H24C27.3137 13 30 15.6863 30 19V26H14C11.7909 26 10 24.2091 10 22Z"
			fill="url(#paint0_linear_21575_22698)"
		/>
		<path d="M20.8334 26L24.5 13H26C28.2092 13 30 14.7909 30 17V26H20.8334Z" fill="#4A4A4A" />
		<path
			d="M12.5 17C12.2239 17 12 16.7761 12 16.5C12 16.2239 12.2239 16 12.5 16L17.5 16C17.7761 16 18 16.2239 18 16.5C18 16.7761 17.7761 17 17.5 17L12.5 17Z"
			fill="white"
		/>
		<defs>
			<linearGradient id="paint0_linear_21575_22698" x1="31.5" y1="26" x2="10" y2="26" gradientUnits="userSpaceOnUse">
				<stop stopColor="#E4EDFC" />
				<stop offset="1" stopColor="#568DFE" />
			</linearGradient>
		</defs>
	</svg>
)
